/**
 * Utility functions for data manipulation operations
 */

/**
 * Removes temporary ID properties from objects in an array or object
 * Used to clean data before saving to backend
 * Creates a deep copy to ensure original data remains immutable
 */
export const stripTempIds = <T extends Record<string, any>>(data: T): T => {
  if (!data) return data;
  
  // Create a deep copy to prevent any mutations to the original data
  const cleanData = structuredClone(data);
  
  // Handle arrays of objects that might have __tempId
  Object.keys(cleanData).forEach(key => {
    const value = cleanData[key];
    if (Array.isArray(value)) {
      (cleanData as any)[key] = value.map(item => {
        if (typeof item === 'object' && item !== null && '__tempId' in item) {
          const { __tempId, ...cleanItem } = item;
          return cleanItem;
        }
        return item;
      });
    }
  });
  
  return cleanData;
};

/**
 * Generates a unique temporary ID for UI operations
 * Format: timestamp_randomString
 */
export const generateTempId = (): string => {
  return `${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
};